import { WithDefaultLayout } from '../../../components/DefautLayout';
import { Title } from '../../../components/Title';
import { Page } from '../../../types/Page';
import { SectionWorkshopProcedure } from '@/components/home/SectionWorkshopProcedure';
import { BenefitPoint } from '@/components/program/BenefitPoint';
import { ChecklistProgram } from '@/components/program/ChecklistProgram'
import { NewSkillBox } from '@/components/program/NewSkillBox';
import MobileAppWorkshopSchedule from '@/components/course/schedule/MobileAppWorkshopSchedule';
import Link from 'next/link';
import { HeaderSection } from '@/components/common/headers/HeaderSection';
import { MobileAppCourseReason } from '@/components/course/section/MobileAppCourseReason';

const WorkshopMobileApplication: Page = () => {
    return (
        <div>
            <Title title={'Workshop - Mobile Application'} description='' />
            <section id='landing-page-mobile-application' className='flex flex-wrap justify-between items-center'>
                <div className='text-2xl mx-5 mb-4'>
                    <div className='m-5 p-5'>
                        <img src='/img/layouting/logo-accelist.png' style={{ width: 74 }} alt='img' />
                        <p className='text-3xl font-bold text-accelist-green mb-3 md:mb-5 mt-4'>Workshop</p>
                        <p className='text-3xl md:text-3xl text-slate-900 font-bold'>Coding</p>
                        <p className='text-3xl md:text-3xl text-slate-900 font-bold mb-2'>Kickstart</p>
                        <div className='w-fit bg-slate-900 rounded-lg px-1 py-2 mt-3 md:mt-5' style={{ width: 300 }}>
                            <p className='text-white text-base md:text-lg text-center px-2'>Kelas Mulai : Januari 2024</p>
                        </div>
                        <p className='text-xl md:text-2xl text-slate-900 font-bold mt-4 md:mt-3'>Mobile Application</p>
                        <p className='text-base md:text-lg text-slate-900 font-bold mt-2 md:mt-3'>2 hari Belajar + Pembuatan Project</p>
                        <p className='text-sm md:text-base text-gray-400 mt-2'>Pengajaran untuk membuat front-end Mobile</p>
                        <p className='text-sm md:text-base text-gray-400'>Application (Android dan iOS) dengan coding</p>
                        <div className="bg-accent-100 rounded-md hover:bg-black duration-300 flex justify-center items-center mt-6 mb-2" style={{ width: 200, height: 50 }}>
                            <Link href="/courses/register" className='block duration-300 text-white hover:text-white text-lg md:text-xl text-accelist-font md:mt-2 mb-2'>
                                Daftar Program
                            </Link>
                        </div>
                    </div>
                </div>
                <div className='relative m-0 flex justify-end'>
                    <img src='/img/course/workshop-mobile-application.png' alt='Workshop - Mobile Application.png' style={{ height: '700px' }} />
                    <div className='absolute inset-0 bg-[#3B4687CC] opacity-80'></div>
                    <div className='absolute inset-0 flex flex-col items-center justify-center'>
                        <p className='text-2xl md:text-2xl mb-2 font-bold text-white text-center'>Workshop rasa Bootcamp!</p>
                        <p className='text-2xl md:text-2xl mb-1 font-bold text-white text-center'>Buat Mobile Apps dengan Coding dalam 2 hari!</p>
                        <div className='border-2 md:border-2 border-white rounded-full mb-6' style={{ width: '38rem' }} />
                        <div className="bg-slate-800 rounded-xl py-2" style={{ width: '100%', maxWidth: '400px', margin: '0 auto' }}>
                            <p className='text-lg md:text-lg font-bold ml-6 mt-4 mb-4 text-white'>Benefit yang didapatkan</p>
                            <div className='text-md flex flex-col flex-wrap text-white pb-2'>
                                <ChecklistProgram name='Cocok bagi pemula' />
                                <ChecklistProgram name='Real project perusahaan' />
                                <ChecklistProgram name='Sesi Interaktif via Live Zoom' />
                                <ChecklistProgram name='Pembuatan aplikasi Android dan iOS sampai jadi!' />
                                <ChecklistProgram name='Diajar oleh expert di Perusahaan IT' />
                                <ChecklistProgram name='Sertifikat digital terverifikasi DISNAKER' />
                                <ChecklistProgram name='Software Skill; JavaScript, TypeScript, React Native, Expo, Tailwind CSS, Expo Application Service (EAS)' />
                            </div>
                            <div className="flex justify-center items-center mt-5 mb-3">
                                <div className="bg-[#F8FAFC] rounded-md" style={{ width: '25rem', height: '2.5rem' }}>
                                    <div className="flex justify-center items-center text-black font-bold text-md mt-2">
                                        <p className="pl-2 mr-4 pr-4 mb-8 border-r border-gray-400 ">Konten Live Session</p>
                                        <p className="mb-8 mx-1">Sesi Sharing</p>
                                        <p className="ml-4 pl-4 mb-8 border-l border-gray-400">Sertifikasi</p>
                                    </div>
                                </div>
                            </div>
                            <p className='text-lg md:text-lg text-center font-semibold text-white'>Daftar Murah Hanya </p>
                            <p className='mt-0'>
                                <span className="currency">Rp</span>
                                <span className="price">7.999.000</span>
                                <span className="currency-discount">Rp</span>
                                <span className="discount">560.000</span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section id='program-description' className='bg-program-atas'>
                <div className='mx-24'>
                    <div>
                        <div className='flex flex-wrap items-center justify-center'>
                            <p className='text-4xl font-bold text-white mt-16 mb-5'>Mobile Application</p>
                        </div>
                        <div className='text-2xl text-gray-400 flex items-center justify-center'>
                        </div>
                        <div className='flex items-center justify-center'>
                            <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mb-5' />
                        </div>
                    </div>
                    <div>
                        <div className='text-xl text-white'>
                            <p className='text-3xl font-bold text-white my-10'>Deskripsi</p>
                            <p>Coding Kickstart: Mobile Application merupakan salah satu kursus murah meriah dan cepat bagi para calon front-end mobile application developer (Android dan iOS). Melalui kursus ini, para peserta akan belajar dan dibimbing untuk membuat mobile application. Kursus ini akan menghasilkan mobile application yang menarik, interaktif, dan dapat diakses di mobile smartphone anda.</p>
                        </div>
                    </div>
                    <p className='text-3xl font-bold text-white my-10'>Agenda dan Materi</p>
                    <div className='text-xl text-accelist-font flex flex-col flex-wrap text-white pb-10'>
                        <BenefitPoint name='Install developer tools (Visual Studio Code, Node.js, Expo Go) dan setup Expo project' />
                        <BenefitPoint name='Pengenalan JavaScript dan TypeScript' />
                        <BenefitPoint name='Pengenalan React' />
                        <BenefitPoint name='Navigasi antar halaman di Next.js' />
                        <BenefitPoint name='Navigasi antar halaman di React Native' />
                        <BenefitPoint name='Menampilkan data list dari web API' />
                        <BenefitPoint name='Mengembangkan form di halaman Mobile dan integrasi ke Back-End' />
                        <BenefitPoint name='Mengembangkan reusable component di React Native menggunakan Tailwind CSS' />
                        <BenefitPoint name='Publish aplikasi mobile via EAS' />
                        <BenefitPoint name='Q&A' />
                    </div>
                </div>
            </section>
            <section id='program-price' className='py-12'>
                <div className="flex flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-4 md:mb-8 items-center">
                        <HeaderSection
                            title="Biaya Program"
                            subtitle="Biaya dari Setiap Paket"
                        />
                    </div>
                    <div className="w-full relative p-5 rounded-xl bg-gradient-to-r from-secondary-80 via-secondary-10 to-secondary-80">
                        <div className="flex flex-wrap justify-between w-full pt-12  pl-5 pr-2 md:px-14 h-full bg-secondary-100 rounded-xl">
                            <div className='absolute z-10 -right-3 lg:-right-16 -top-5 lg:-top-12 w-[90px] lg:w-[180px] h-[90px] lg:h-[180px] rounded-[45px] lg:rounded-[90px] bg-gradient-to-r from-gradientsilver-7 via-gradientsilver-9 to-gradientsilver-7 flex items-center justify-center'>
                                <div className='text-center flex flex-col items-center justify-center bg-gradient-to-br from-gradientsilver-10 via-gradientsilver-9 to-gradientsilver-7 w-[82px] lg:w-[164px] h-[82px] lg:h-[164px] rounded-[41px] lg:rounded-[82px]'>
                                    <p className='text-sm lg:text-3xl text-secondary-100 font-body font-bold'>Hemat</p>
                                    <p className='text-sm lg:text-3xl text-secondary-100 font-body font-bold'>7 Juta!</p>
                                </div>
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-2xl sm:text-4xl font-bold text-[#CDCDCD] mb-6'>Mobile Application</p>
                                <p className='text-2xl sm:text-6xl font-bold text-[#CDCDCD] mb-16'>Rp560,000</p>
                                <p className='text-md sm:text-xl font-bold text-[#B3B3B3] mb-2'>Rp93.000 / bulan</p>
                                <p className='text-md sm:text-xl font-bold text-[#B3B3B3] mb-8'>Durasi 6 Jam</p>
                                <p className='text-md sm:text-sm text-[#CDCDCD] mb-6'>Sudah bisa membuat mobile application dengan coding</p>
                                <div className='w-fit bg-gradient-to-r from-[#45494B] via-[#FFFFFF] to-[#45494B] p-3'>
                                    <Link href="/courses/register" className='hover:bg-[#CDCDCD] duration-300 transition ease-in-out bg-gradient-to-r from-[#45494B] via-[#FFFFFF] to-[#45494B] rounded-md'>
                                        <p className='text-md sm:text-xl text-secondary-100 font-body font-bold'>Daftar Sekarang</p>
                                    </Link>
                                </div>
                            </div>
                            <img src='/img/program/detail-paket-silver.png' alt='' className='w-fit'></img>
                        </div>
                    </div>
                </div>
            </section>
            <section id='program-schedule' className='py-16'>
                <div className="flex-wrap px-5 md:px-16">
                    <MobileAppWorkshopSchedule />
                </div>
            </section>
            <section id='acquired-skills' className='pb-10'>
                <div className="px-5 md:px-16 bg-[#f5f5f5]">
                    <div className="flex flex-col mx-auto text-center md:mb-16 items-center gap-6">
                        <h2 className='text-secondary-100 text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed mt-16'>Skill yang Bisa Kamu Tambah di CV!</h2>
                        <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mb-5' />
                    </div>
                    <div className='align-middle flex flex-wrap font-semibold justify-evenly text-md text-black pb-16'>
                        <NewSkillBox name='Front-End Mobile Development' />
                        <NewSkillBox name='React Native' />
                        <NewSkillBox name='Expo' />
                        <NewSkillBox name='JavaScript' />
                        <NewSkillBox name='EAS' />
                        <NewSkillBox name='TypeScript' />
                        <NewSkillBox name='Tailwind CSS' />
                        <NewSkillBox name='Responsive Design' />
                    </div>
                </div>
            </section>
            <section id='acquired-skills' className='pb-10'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center">
                        <h2 className='text-secondary-100 text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed'>Kenapa Harus Ikut Coding Kickstart: Mobile Application?</h2>
                        <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mt-3 md:mt-5' />
                    </div>
                    <div className='flex flex-wrap justify-evenly'>
                        <MobileAppCourseReason />
                    </div>
                </div>
            </section>
            <section id='achieve-your-dream-with-us' className='bg-program-bawah'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center mt-16">
                        <h2 className='text-white text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed'>Wujudkan Mimpimu Bersama Kami</h2>
                        <p className="text-white text-base font-body font-light align-center mt-1 md:mt-3 sm:text-lg mb-16">Satu langkah untuk mewujudkan mimpi mu</p>
                        <Link href="/courses/register" className="text-sm sm:text-base font-medium font-body bg-accent-100  text-white py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out hover:bg-white hover:text-accent-100 shrink">
                            <p className='text-md sm:text-xl font-body font-bold'>Daftar Program</p>
                        </Link>
                    </div>
                </div>
            </section>
            <SectionWorkshopProcedure />
            <section id='program-requirements' className='pb-20'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center">
                        <h2 className='text-secondary-100 text-2xl font-body font-bold align-center sm:text-4xl mb-3 leading-relaxed'>Persyaratan Program</h2>
                        <p className="text-secondary-60 text-base font-body font-light align-center sm:text-lg">Minimum Spesifikasi Perangkat</p>
                        <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 md:mt-5' />
                    </div>
                    <div className='flex flex-wrap justify-evenly'>
                        <div className='flex flex-wrap p-8 bg-white shadow-[4px_4px_6px_0px_#0D948838] mb-4 sm:mb-8 w-96'>
                            <img src="/img/program/laptop.png" alt="img" className="w-16 h-16" />
                            <div className='mx-4 mt-2 text-lg font-semibold'>
                                Komputer
                                <ul className='list-disc pl-6'>
                                    <li className='text-sm'>CPU: 4 Cores</li>
                                    <li className='text-sm'>RAM: 8 GB</li>
                                    <li className='text-sm'>Storage: 5 GB</li>
                                    <li className='text-sm'>OS: Windows/ Linux / macOS</li>
                                </ul>
                            </div>
                        </div>
                        <div className='flex flex-wrap p-8 bg-white shadow-[4px_4px_6px_0px_#0D948838] w-96'>
                            <img src="/img/course/icon-handphone.png" alt="img" className="w-16 h-16" />
                            <div className='mx-4 mt-2 text-lg font-semibold'>
                                Handphone
                                <ul className='list-disc pl-6'>
                                    <li className='text-sm'>Storage : 1 GB</li>
                                    <li className='text-sm'>OS: Android 5+ / iOS 13+</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="flex flex-col flex-wrap px-5 md:px-16">
                <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center">
                    <Link href="/courses/register" className="text-sm sm:text-base font-medium font-body text-white bg-accent-100 py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out hover:bg-black hover:text-white shrink">
                        <p className='text-md sm:text-xl text-white font-body font-bold'>Daftar Sekarang</p>
                    </Link>
                </div>
            </div>
        </div>
    )
}

WorkshopMobileApplication.layout = WithDefaultLayout;
export default WorkshopMobileApplication;